"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _SetPassword = _interopRequireDefault(require("./SetPassword"));

var _BasicProfile = _interopRequireDefault(require("../../BasicProfile"));

var _InviteAuthProtected = _interopRequireDefault(require("../../InviteAuthProtected"));

require("../styles/_first-time-setup.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function FirstTimeSetup(_ref) {
  var children = _ref.children,
      user = _ref.user,
      apolloClient = _ref.apolloClient,
      onUpdateUser = _ref.onUpdateUser,
      createUser = _ref.createUser,
      tempToken = _ref.tempToken,
      organisationId = _ref.organisationId,
      organisationName = _ref.organisationName;
  return _react.default.createElement(_InviteAuthProtected.default, {
    apolloClient: apolloClient,
    shouldShowLogin: Boolean(user.userId),
    user: user,
    organisationName: organisationName
  }, function (_ref2) {
    var loggedInUser = _ref2.loggedInUser,
        onLogin = _ref2.onLogin;
    return loggedInUser && user.email === loggedInUser.email && user.initialSetup ? children : _react.default.createElement(_uiKit.Wizard, {
      className: "first-time-setup",
      initialStage: user.userId ? 2 : 1,
      hideBack: true
    }, _react.default.createElement(_SetPassword.default, {
      apolloClient: apolloClient,
      onUpdateUser: onUpdateUser,
      tempToken: tempToken,
      createUser: createUser,
      organisationId: organisationId,
      user: user,
      onLogin: onLogin
    }), _react.default.createElement(_BasicProfile.default, {
      apolloClient: apolloClient,
      user: user,
      onUpdateUser: onUpdateUser,
      isFirstTimeSetup: true,
      organisationId: organisationId,
      title: "Tell us more about yourself",
      subtitle: "Awesome stuff!"
    }));
  });
}

var _default = (0, _react.memo)(FirstTimeSetup);

exports.default = _default;